module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"placeholder":"管理元","all":"すべて","distributors":"代理店"},"en":{"placeholder":"Managed by","all":"All","distributors":"Distributors"}}')
  delete Component.options._Ctor
}
